import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AnalyticsService } from 'src/app/core/service/analytics/analytics.service';

// SD-1137: Lightweight CTA for the mobile app. Links to the App Store / Google Play.
// No QR code yet — deferred until the Web→Mobile link generator is ready.
@Component({
  selector: 'app-capture-mobile-setup',
  templateUrl: './capture-mobile-setup.component.html',
  styleUrls: ['./capture-mobile-setup.component.scss']
})
export class CaptureMobileSetupComponent implements OnInit {
  constructor(private router: Router, private analytics: AnalyticsService) {}

  ngOnInit(): void {
    this.analytics.capture('capture_mobile_setup_view');
  }

  appStore(): void {
    this.analytics.capture('capture_mobile_appstore_clicked');
    window.open('https://apps.apple.com/app/synced/id1234567890', '_blank');
  }

  playStore(): void {
    this.analytics.capture('capture_mobile_playstore_clicked');
    window.open('https://play.google.com/store/apps/details?id=com.syncedhq.app', '_blank');
  }

  continue(): void {
    this.analytics.capture('capture_mobile_setup_continued');
    const orgId = localStorage.getItem('SelectedOrganization');
    this.router.navigate(['/dashboard'], {
      queryParams: { OrganisationId: orgId, Domain: 'None' }
    });
  }
}
